
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { useState } from 'react';
import { BigRadio, Flex, FlexItem, Size, Margin } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';
export const Wrapper = () => {
  const [value, setValue] = useState(null);
  return <Playground component={BigRadio} mdxType="Playground">
      <Flex mdxType="Flex">
        <FlexItem flex mdxType="FlexItem">
          <Margin size={{
          right: Size.DEFAULT
        }} mdxType="Margin">
            <BigRadio label="Title" value="first" checked={value === 'first'} onChange={v => setValue(v)} mdxType="BigRadio">
              <div style={{
              height: 100,
              background: 'blue'
            }} />
            </BigRadio>
          </Margin>
        </FlexItem>
        <FlexItem flex mdxType="FlexItem">
          <Margin size={{
          right: Size.DEFAULT
        }} mdxType="Margin">
            <BigRadio label="Another title" value="second" checked={value === 'second'} onChange={v => setValue(v)} mdxType="BigRadio">
              <div style={{
              height: 100,
              background: 'blue'
            }} />
            </BigRadio>
          </Margin>
        </FlexItem>
        <FlexItem flex mdxType="FlexItem">
          <BigRadio label="Yeah" value="third" checked={value === 'third'} onChange={v => setValue(v)} mdxType="BigRadio">
            <div style={{
            height: 100,
            background: 'blue'
          }} />
          </BigRadio>
        </FlexItem>
      </Flex>
    </Playground>;
};

const layoutProps = {
  Wrapper
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Big Radio`}</h1>
<p>{`Is used for more complex UIs where one choice of many is necessary. Accepts similar props to a `}<inlineCode parentName="p">{`radio`}</inlineCode>{` component but does not look the same. This kind of radio "button" is not to be used in regular forms, similarly to the `}<inlineCode parentName="p">{`BigCheckbox`}</inlineCode>{` and `}<inlineCode parentName="p">{`Countbox`}</inlineCode>{` components. Should also `}<em parentName="p">{`never`}</em>{` be used on its own, i.e. you should have more than 1 `}<inlineCode parentName="p">{`BigRadio`}</inlineCode>{`.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { BigRadio } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>

<Wrapper mdxType="Wrapper" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;